import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useCart } from "../../hooks/useCart";
import { HiMenu, HiX } from "react-icons/hi";

// You can move this to a config file or environment variable
const ENROLL_URL = "https://neartail.com/sm/R6euoe07d";

const Navbar = () => {
  const { user, logout } = useAuth();
  const { cart } = useCart();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate("/");
  };

  const handleLinkClick = () => setIsOpen(false);

  const totalItems = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);

  return (
    <nav className="bg-gray-100 shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center px-4 py-3">
        {/* Logo 
        <Link to="/" className="text-xl font-bold text-gray-800" onClick={handleLinkClick}>
          MyApp
        </Link> */}

        <Link to="/" className="flex items-center" onClick={handleLinkClick}>
          <img
            src="media/img/logo.png"
            alt="SPK Academy & Publishing"
            className="h-16 w-auto" 
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-4 items-center text-gray-800">
          <Link to="/services" className="hover:underline" onClick={handleLinkClick}>Services</Link>
          <Link to="/books" className="hover:underline" onClick={handleLinkClick}>Books</Link>
          <Link to="/classes" className="hover:underline" onClick={handleLinkClick}>Classes</Link>
          <Link to="/about" className="hover:underline" onClick={handleLinkClick}>About</Link>
          <Link to="/contacts" className="hover:underline" onClick={handleLinkClick}>Contacts</Link>

          {/* Enroll Link (external) */}
          <a
            href={ENROLL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded transition-colors"
            onClick={handleLinkClick}
          >
            Enroll Now
          </a>

          {user ? (
            <>
              <Link to="/dashboard" className="hover:underline" onClick={handleLinkClick}>Dashboard</Link>
              <button
                onClick={handleLogout}
                className="bg-white text-blue-600 px-3 py-1 rounded hover:bg-gray-200"
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="bg-white text-blue-600 px-3 py-1 rounded hover:bg-gray-200"
              onClick={handleLinkClick}
            >
              Login
            </Link>
          )}

          {/* Cart Icon Desktop */}
          <Link
            to="/cart"
            className="relative ml-4 text-blue-600 hover:text-blue-800"
            onClick={handleLinkClick}
            aria-label="View cart"
          >
            🛒
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {totalItems}
              </span>
            )}
          </Link>
        </div>

        {/* Mobile Icons: Cart + Hamburger */}
        <div className="md:hidden flex items-center space-x-4 text-gray-800">
          {/* Cart always visible */}
          <Link
            to="/cart"
            className="relative text-blue-600 hover:text-blue-800"
            onClick={handleLinkClick}
            aria-label="View cart"
          >
            🛒
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[0.65rem] px-1.5 py-0.5 rounded-full">
                {totalItems}
              </span>
            )}
          </Link>

          {/* Hamburger */}
          <button onClick={toggleMenu} className="text-gray-800 text-2xl focus:outline-none" aria-label="Toggle menu">
            {isOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-gray-400 px-4 py-1 pb-4 space-y-2 text-white">
          {/* Enroll Link first on mobile */}
          <a
            href={ENROLL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700"
            onClick={handleLinkClick}
          >
            Enroll Now
          </a>

          <Link to="/services" className="block" onClick={handleLinkClick}>Services</Link>
          <Link to="/books" className="block" onClick={handleLinkClick}>Books</Link>
          <Link to="/classes" className="block" onClick={handleLinkClick}>Classes</Link>
          <Link to="/about" className="block" onClick={handleLinkClick}>About</Link>
          <Link to="/contacts" className="block" onClick={handleLinkClick}>Contacts</Link>

          {user ? (
            <>
              <Link to="/dashboard" className="block" onClick={handleLinkClick}>Dashboard</Link>
              <button
                onClick={handleLogout}
                className="w-full text-left bg-white text-blue-600 px-3 py-1 rounded hover:bg-gray-200"
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="block bg-white text-blue-600 px-3 py-1 rounded hover:bg-gray-200"
              onClick={handleLinkClick}
            >
              Login
            </Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;